module.exports = __webpack_public_path__ + "media/images/top/pap/icon/white/ico_minus-e8a3d160058e8f38020e4a8bfde0d578.svg";